import { Stack } from 'expo-router';
import { ScrollView } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import EventShareCalendarDownload from '@/components/Event/EventShare/EventShareCalendarDownload';
import EventShareCalendarSync from '@/components/Event/EventShare/EventShareCalendarSync';
import Box from '@/components/UI/Box';

export default function EventShareHome() {
  return (
    <ScrollView contentContainerStyle={style.scrollView}>
      <Stack.Screen options={{ title: 'Sync & Share' }} />
      <Box space="lg" p="lg" alignItems="center">
        <EventShareCalendarSync />
        <EventShareCalendarDownload />
      </Box>
    </ScrollView>
  );
}

const style = StyleSheet.create((_, rt) => ({
  scrollView: {
    paddingBottom: rt.insets.bottom,
  },
}));
